import { Component, OnInit } from '@angular/core';
import {ServicesComponent} from "../services.component";
import {WebDesignComponent} from "./web-design.component";

@Component({
  selector: 'app-seo',
  template: `
     <div class="service-detail" id="top">
        <h2><span class="bottomBorder" style="padding-bottom: 4%;">SEO</span> SERVICE</h2>
        <div class="scale-less-margin"></div>
        <article>Search engine optimisation (SEO) of your website can increase the visibility of your website in search engine results. 
         When a potential customer is looking for a product or service using a search engine the higher your website appears increases the likely hood they will click on your link. </article>
        <article style="margin-bottom: 6%">The higher your appear for relevant search keywords, increases dramatically the amount of traffic your website will receive.
        </article>
        <div class="details-container first">
          <div class="checked"></div>
          <h5>Search engine optimisation</h5></div>
        <p style="display: block" class="slider">As time is moving on the old methods of advertising such as telephone directories are becoming obsolete and people searching for a business or product are switching to searching the internet. This is were search engine optimisation (SEO for short) is becoming increasingly more important. </p>
        <div class="details-container second">
          <div class="checkMark"></div>
          <h5>Analytics & monitoring</h5></div>
        <p class="slider">Creative Digital track and monitor all our clients websites for SEO performance and can monitor a wide variety of analytical data to determine how well keywords and search engine optimisation techniques are working. </p>
        <div class="details-container third">
          <div class="checkMark"></div>
          <h5>Competitor Analysis</h5></div>
        <p class="slider">Just like we can report on how to improve your websites performance, we can also report on how your competitors are also performing.  Having excellent information at hand of how your competitors websites are optimised for search engines can be key to getting longer lasting and quicker results. </p>
      </div>
  `,
  styleUrls: ['./seo.component.css']
})
export class SeoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.slider();
    WebDesignComponent.firstStart(this, 2);
  }

  slider () {
    $('.first').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.second').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.third').click(function () {
      WebDesignComponent.initializeSlide(this);
    });

    $('.forth').click(function () {
      WebDesignComponent.initializeSlide(this);
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/services/descriptionComponents/seo.component.ts